import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { NotificationComponent } from '../notification/notification.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(public snackBar: MatSnackBar) { }

  showError(errorMessages: any) {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: errorMessages
    });
  }

  showInfo(infoMessage: string) {
    this.snackBar.open(infoMessage, 'OK', { duration: 2000 });
  }
}
